import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { API_HOST, PLAGIUS_API_HOST, UserContext, getTenant } from '../consts';
import { LinearProgress, Typography } from '@material-ui/core';
import PlagiarismTable from './TablePlagius';
import Loading from './Loading';

class Plagius extends React.Component {

  state = {
    fetching: false,
    itemId: null,
    plagius: {},
    queueId: null,
    result: null,
    values: {},
    clicked: false,
    url: null
  };

  extractUrls = (html) => {
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");
		const urls = [];
		const rows = doc.querySelectorAll("div > blockquote > table > tbody > tr");
		rows.forEach((row, index) => {
			if (index === 0) return; 
			const columns = row.querySelectorAll("td");
			if (columns.length === 3) {
				const url = columns[0].querySelector("a").getAttribute("href") || "";
				const occurrences = parseInt(columns[1].textContent || "0", 10);
				const similarity = columns[2].textContent || "";
				urls.push({ url, occurrences, similarity });
			}
		});

		return urls;
	};

  formatDate(dataISO) {
    const data = new Date(dataISO);
    const dataBrasileira = data.toLocaleDateString("pt-BR", {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
    const horaBrasileira = data.toLocaleTimeString("pt-BR", {
        hour: '2-digit',
        minute: '2-digit'
    });
    return `${dataBrasileira} às ${horaBrasileira}`;
  }


  componentDidMount() {
    const itemId = this.props.item;
    this.setState({ itemId: itemId });
    this.getLastPlagium();
    this.fetchItem()
  }

  fetchItem = () => {
    const { item } = this.props;
    axios.get(`${API_HOST}/itens/item/${item}`).then(
      response => this.setState({ values: { situacao_problema: response.data.situacao_problema, comando_resposta: response.data.comando_resposta } })
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.fetching && !prevState.fetching) {
      this.interval = setInterval(this.getPlagium, 20000);
    } else if (!this.state.fetching && prevState.fetching) {
      clearInterval(this.interval);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  stripHtml = (html) => {
    if (html) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      return doc.body.textContent || "";
    } else {
      return "";
    }
  };

  getQueueIdPlagium = async () => {
    try {
      const data = {
        message: `${this.stripHtml(this.state.values.situacao_problema)} ${this.stripHtml(
          this.state.values.comando_resposta
        )}`,
        externalId: `${this.state.itemId}`,
        source: "cmmg",
        priority: 1000
      };
      this.setState({ fetching: true });
      const response = await axios.post(
        `${API_HOST}/itens/item/${this.state.itemId}/get_plagio_queue_id`,
        data
      );
      if (response) {
        this.setState({ queueId: response.data.queueId });
      }
    } catch (error) {
      console.error(error);
    }
  };

  getPlagium = async () => {
    try {
      const response = await axios.get(`${API_HOST}/itens/item/${this.state.queueId}/get_plagio_result`).then(
        response => {
          if (response.data && response.data.result) {
            this.setState({ result: response.data,url: this.extractUrls(response.data.result) });
            const data = {
              plagio_id: response.data.id,
              plagio_resultado: response.data.result,
              plagio_similaridade: response.data.plagiarism,
              plagio_prioriade: response.data.priority,
              criado_em: response.data.createdAt,
              atualizado_em: response.data.processedAt
            }
            axios.post(`${API_HOST}/itens/item/${response.data.externalId}/save_plagio`, data).then(res => console.log(res))
            this.setState({ fetching: false });
          }
        }
      );

    } catch (error) {
      console.error(error);
    }
  };

  getLastPlagium = async () => {
    try {
      const params = {
        source: "cmmg",
        externalId: `${this.props.item}`
      };
      const response = await axios.get(
        `${API_HOST}/itens/item/${this.props.item}/get_plagio_by_item_id`,
        { params }
      ).then(response => {
        if (response.data.plagio_resultado) {
          this.setState({
            result: {
              result: response.data.plagio_resultado,
              plagiarism: response.data.plagio_similaridade,
              processedAt: response.data.atualizado_em
            },
            url: this.extractUrls(response.data.plagio_resultado)
          });

        }
      });
    } catch (error) {
      console.error(error);
    }
  };


  render() {
    const {result, url, fetching } = this.state;
    return (
      <>
        {result && !fetching && result.result &&  (
          <div style={{width:'100%'}}>
            <div style={{width:'100', display:'flex', justifyContent:'right', alignItems:'center'}}>
              <Typography variant="body1">Atualizado em: {this.formatDate(result.processedAt)}</Typography>
            </div>
            <div style={{display:'flex', gap:'5px', alignItems:'center'}}>
              <Typography variant="body1">Porcentagem de plagiamento:</Typography>
              <Typography variant="body2">{result.plagiarism}%</Typography>
            </div>
            <LinearProgress
              variant="determinate"
              value={result.plagiarism}
              style={{ height: 10, borderRadius: 5 }}
            />
            {console.log(url)}
            <PlagiarismTable data={url}/>
          </div>
        )}

        {fetching && (
          <div style={{width:'100%', gap:'10px'}}>
            <Typography variant="body1">Aguarde cerca de 2 a 4 minutos</Typography>
            <Loading/>
          </div>
        )}
        {
          !fetching && (
            <div style={{marginTop:'10px'}}>
              <button className="btn btn-padrao bg-padrao" onClick={() => {
                this.setState({
                  clicked: true
                })
                this.getQueueIdPlagium()
              }}>{result && result.result ? 'Analisar novamente': 'Analisar' }</button>
            </div>
          )
        }
      </>
    );
  }
}

Plagius.propTypes = {
  item: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

export default (props) => (
  <UserContext.Consumer>
    {({ permissions }) => <Plagius permissions={permissions} {...props} />}
  </UserContext.Consumer>
);

